export enum InterventionFoodSafetyTypes {
  PREHARVEST_REQUEST = 'preharvest request',
  REQUEST_FOR_AUDIT = 'request for audit',
  REQUEST_FOR_CREW_TAILGATE = 'request for crew tailgate',
  REVIEW_APPLIED_BUFFER = 'review applied buffer',
  REVIEW_CAFO_DISTANCE = 'review cafo distance',
  REVIEW_PEST_CONTROL = 'review pest control',
}
